import { Component, ComponentFactory, ComponentFactoryResolver, EventEmitter, Input, OnChanges, OnInit, OnDestroy, Output, SimpleChanges, Type, ViewChild, ViewContainerRef, HostListener, AfterViewInit, ComponentRef } from '@angular/core';

import ValidationEngine from "devextreme/ui/validation_engine";
import notify from 'devextreme/ui/notify';

import { messagefromComponent } from '../../class/appinterface';

import { AnagraficaService } from '../../services/anagrafica.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaFormComponent } from '../nica-form/nica-form.component';

import { alert } from 'devextreme/ui/dialog';
import { NicaFormToolbarComponent } from '../shared/nica-form-toolbar/nica-form-toolbar.component';
import { DxDataGridComponent, DxListComponent } from 'devextreme-angular';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import CustomStore from 'devextreme/data/custom_store';
import validationEngine from 'devextreme/ui/validation_engine';
import { isString } from 'util';
import { Apiservice } from '../../services/api.service';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import { type } from 'os';
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: 'app-nica-dynamic-content',
  templateUrl: './nica-dynamic-content.component.html',
  styleUrls: ['./nica-dynamic-content.component.css']
})
export class NicaDynamicContentComponent implements OnInit, AfterViewInit {

  @ViewChild('containerComponent', { static: false, read: ViewContainerRef }) containerComponent: ViewContainerRef;


  @ViewChild('dynamicGridComponent', { static: false }) dynamicGridComponent: DxDataGridComponent;
  @ViewChild('dynamicComponentItemDetail', { static: false }) dynamicComponentItemDetail: NicaDynamicContentComponent;
  @ViewChild('dynamicList', { static: false }) dynamicList: DxListComponent;

  @Input() gridHeight: number;
  @Input() apiSource: string;
  @Input() service: string;
  @Input() remoteOperations: boolean;
  @Input() componentType: string;
  @Input() filterKey: string = '';
  @Input() componentData: any[];
  @Input() columnAutoWidth: boolean = true
  @Input() width: string;
  @Input() height: string;
  @Input() editingGrig: boolean;
  @Input() dataInput: any[]
  @Input() disabledDynamicElement: boolean = false
  @Input() costantValues: any;
  @Input() dataForm;
  @Input() itemData;
  @Input() desButtonAdd;
  @Output() emittendSelectionRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() emittendSelectionMultipleRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() emittedToolbarEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() emittedGridEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() emittedGridEventInit: EventEmitter<any> = new EventEmitter<any>();
  detailMasterData: any;
  colsButton: any = [];


  cols: any = [];
  colsSum: any = [];
  inSelectionState: boolean = true
  datasource: any = [];
  filterNomeTabella: string;
  searchValueString: string;
  filter: string;
  formActionType: string
  dataSetJson: any = [];
  @Input() name: any;
  lookUpData: any[] = []
  componentRef: ComponentRef<any>;
  listButtonOptions: any;
  buttonCustom: { location: string; widget: string; locateInMenu: string; text: string; icon: string; event: string; }[];
  modeEditNicaAnagrafica: any = 'popup';
  selectedDataGrid: any[] & Promise<any>;
  keyUnique: any = 'index';
  callbacks = [];
  borderStyle: string = "none";
  nicaAnagraficaEditor: boolean[] = [true];
  disabledDynamicGrid: boolean = false;
  dataSelectedList: any = [];
  dataSelectedGrid: any = [];

  /** Vairiabili globali relative a nellla grigia alle colonne di di tipo lookup multiselect **/
  rowSelectLookUp: any[] = []
  rowSelectedLookUp: any[] = [];
  lookUpValue: any[] = [];
  isGridInEdit: boolean = false;
  showFilterSearch: boolean = true
  datasourceCopy: any[] = [];
  isPanelVisible: boolean = false;
  bottonisottogriglia: boolean = true;
  typeFormart: any = [];
  adapterConfig = {

    getValue: () => {
      return this.datasource;
    },
    applyValidationResults: (e) => {
      this.borderStyle = e.isValid ? "none" : "1px solid red";
    },
    validationRequestsCallbacks: this.callbacks
  };
  settingsComponent: any[];
  PulsantiSuNavBar: { location: string; options: { icon: string; title: string; text: string; index: number; id: string; }; }[];
  currEditIndx: any;
  currDataFieldEdit: any;
  currEditIndexTarget: any[] = [];
  targetCompare: any;
  added: boolean = false;
  selectedRows: any[] = [];
  onFirstLoad: boolean = true;
  onFirstLoadContentReady: boolean = true;
  ButtonsDataField: any[] = [];
  otherButtonsDataField: any[] = [];
  showColBlank: boolean = true;
  masterKey: any = 'id';
  showDetail: boolean;
  detailData: any[] = [];
  rowDragging: any = {
    allowReordering: false,
    showDragIcons: false,
  }
  larghezzaPopup: any;
  altezzaPopup: any;
  panelCaption: any;
  selectionMode: string;
  showSelectionMode: boolean = true;

  revalidate() {
    this.callbacks.forEach(func => {
      func();
    });
  };
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event) {
    //console.log(event)
    /* if (event.code == '+' || event.code == 'NumpadAdd') {
      event.preventDefault();
      this.dynamicGridComponent.instance.addRow()
      event.stopImmediatePropagation();

    } */
    if (event.code == 'Backquote' || event.code == 'F7') {

      // 

      //this.dynamicGridComponent.instance.closeEditCell()
      //this.onSavingDynamiGrid(event);
      event.preventDefault();
      event.stopImmediatePropagation();

    }


    /* if (event.code == 'F10') {
      event.preventDefault();

      this.formSoggetto.onFormSubmit(event)
      event.stopImmediatePropagation();

    } */
  }

  constructor(private appService: Apiservice, private anagraficaService: AnagraficaService, private formservice: FormsTemplateService, private componentService: ComponentService, private _componentFactoryResolver: ComponentFactoryResolver,
    private _overlaySideFormService: OverlaySideFormService, private utility: UtilityService,
    private _overlaySidePanelService: OverlaySideFormService,
  ) {
    this.chooseRow = this.chooseRow.bind(this);
    this.saveRow = this.saveRow.bind(this);
    this.colonnaButtonClick = this.colonnaButtonClick.bind(this);
    this.isSelIconVisible = this.isSelIconVisible.bind(this);
    this.isEditIconVisible = this.isEditIconVisible.bind(this);
    this.onReorder = this.onReorder.bind(this);
    this.isShowIconDrag = this.isShowIconDrag.bind(this);
    this.close = this.close.bind(this);
    this.popupHiding = this.popupHiding.bind(this);


  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('ngOnChanges', changes)
    if (typeof changes.dataInput != 'undefined') {
      if (typeof changes.dataInput.currentValue != 'undefined' && typeof changes.dataInput.previousValue == 'undefined') {
        if (!changes.dataInput.currentValue || this.remoteOperations) {
          return
        }
        if (changes.dataInput.currentValue.length > 0) {
          //  this.relazionaArray(changes.dataInput.currentValue,[]);
        }


      }
    }

  }


  ngAfterViewInit() {
    /*
    console.log('ngAfterViewInit',this)
    setTimeout(() => {
      //this.ngOnInit();
    }, 200);
    */
    //alert("quaaaaaaaaaaaa","quaaaaaaaaaaaaa")
    let Arrayrelateds = [];
    setTimeout(() => {
      this.relazionaArray(Arrayrelateds);
    }, 200);
    //    this.dataInput=this.dataForm.listGiacenzaRifiutiInizialiDettagli;
    if (typeof this.dataInput != 'undefined' && this.componentType == 'dynamicGrid') {
      // this.renderComponentGridToView()
    }
  }


  /*
  
     ngAfterContentInit(){
    console.log('ngAfterContentInit',)

      //this.renderComponentGridToView()
      if (this.componentType == 'dynamicGrid') {

        this.renderComponentGridToView()
      }
  
      if (this.componentType == 'dynamicList') {
  
        this.renderComponentListToView()
  
      }

    

      //this.renderComponentListToView()

    
  }
  */

  ngOnInit() {
    console.log('wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww', this)

    /* //console.log('componentData', this.componentData);
    //console.log('costantValues', this.costantValues); */
    //console.log('dataInput', this.dataInput);


    if (typeof this.componentData == 'undefined' && typeof this.itemData != 'undefined') {

      /*
            [componentType]="componentType"
            [componentData]="componentData" 
            [filterKey]="filterKey" 
            [height]="height" 
            [width]="width"
            [editingGrig]="enableEditDynamicGrid" 
            [dataInput]="dataSedDynamicContent" 
            [name]="titleDynamic"
            (emittedGridEvent)="emittedGridEvent($event)" 
            [costantValues]="costantValuesToDynamic"
      
      */

      this.componentData = this.itemData[0]['componentData'];
      this.apiSource = this.itemData[0]['apiSource'];
      this.componentType = this.itemData[0]['componentType'];
      this.filterKey = this.itemData[0]['filterKey'];
      this.height = this.itemData[0]['height'];
      this.width = this.itemData[0]['width'];
      this.dataInput = this.itemData[0]['dataInput'];
      this.dataForm = this.itemData[0]['dataForm'];
      this.costantValues = this.itemData[0]['costantValues'];

      if (this.gridHeight > 0) {
        let elementGrid = null
        if (this.name) {
          let xx = this.name.replace(/[ ]/g, '');
          elementGrid = $("#grigliaMaster [name=" + xx + "]")
        }
        if (elementGrid) {
          $(elementGrid).height(this.gridHeight + "px");
          $(elementGrid).css('height', this.gridHeight + "px")
        } else {
          $("#grigliaMaster").height(this.gridHeight + "px");
          $('#grigliaMaster').css('height', this.gridHeight + "px")
        }
      }



    }


    if (this.componentData) {

      if (this.componentData['dynamic']) {

        this.filterNomeTabella = this.componentData['dynamic'].queryStringFilter;

        if (this.componentData['valueSearch'] != '') {
          this.searchValueString = this.componentData['valueSearch'];
        }

        //this.costantValues = this.componentData['dynamic']['costantValue'];

        ////console.log(this.componentData['dynamic']['enableEditor'])
        if (this.componentData['dynamic']['enableEditor']) {

          const enableEditorOBject = this.componentData['dynamic']['enableEditor']
          this.nicaAnagraficaEditor['add'] = this.componentData['dynamic']['enableEditor']['add'];
          this.nicaAnagraficaEditor['remove'] = this.componentData['dynamic']['enableEditor']['remove'];
          this.nicaAnagraficaEditor['update'] = this.componentData['dynamic']['enableEditor']['update'];

        } else if (typeof this.componentData['dynamic']['settingGrid'] != 'undefined') {

          if (this.componentData['dynamic']['settingGrid']['allowUpdating'] || this.componentData['dynamic']['settingGrid']['allowDeleting'] || this.componentData['dynamic']['settingGrid']['allowAdding']) {

            this.nicaAnagraficaEditor['update'] = this.componentData['dynamic']['settingGrid']['allowUpdating'] ? this.componentData['dynamic']['settingGrid']['allowUpdating'] : false;
            this.nicaAnagraficaEditor['remove'] = this.componentData['dynamic']['settingGrid']['allowDeleting'] ? this.componentData['dynamic']['settingGrid']['allowDeleting'] : false;
            this.nicaAnagraficaEditor['add'] = this.componentData['dynamic']['settingGrid']['allowAdding'] ? this.componentData['dynamic']['settingGrid']['allowAdding'] : false;

          }
          if (typeof this.componentData['dynamic']['settingGrid']['bottoniSottoGriglia'] != 'undefined') {

            this.bottonisottogriglia = this.componentData['dynamic']['settingGrid']['bottoniSottoGriglia']
          }
        }

        else {
          this.nicaAnagraficaEditor['add'] = false
          this.nicaAnagraficaEditor['remove'] = false;
          this.nicaAnagraficaEditor['update'] = false;

        }


        if (typeof this.apiSource == 'undefined') {

          this.apiSource = this.componentData['dynamic']['dataSource'];
        }

        if (typeof this.service == 'undefined') {
          this.service = this.componentData['dynamic']['service']
        }
      }


      if (typeof this.costantValues == 'undefined') {


        this.costantValues = this.componentData['costantValue']
      }
    }



    if (typeof this.componentData['dynamic'] != 'undefined') {


      /*       if (this.componentData['dynamic']['filter'] == '/') {
              this.anagraficaService.getElenco(this.apiSource, '', this.filterNomeTabella).then(subject => {
      
                if (subject['items']) {
                  this.datasource = subject['items'];
                } else {
                  this.datasource = subject;
                }
      
              });
              
            }
       */
      if (this.componentData['dynamic']['settingList'] || this.componentData['dynamic']['settingGrid']) {
        this.settingsComponent = this.componentData['dynamic'];

      }
      if (typeof this.componentData['dynamic']['settingDetail'] != 'undefined') {
        this.showDetail = true;
        this.detailData = this.componentData['dynamic']['settingDetail']
        this.detailData['dataField'] = this.componentData['dataField'];
        //console.log('detailData', this.detailData)

      }

      if (typeof this.componentData['dynamic']['settingGrid'] != 'undefined') {
        this.keyUnique = this.componentData['dynamic']['settingGrid']['keyUnique'];
        if (typeof this.componentData['dynamic']['settingGrid']['masterKey'] != 'undefined') {
          this.masterKey = this.componentData['dynamic']['settingGrid']['masterKey'];
        }


        if (typeof this.componentData['dynamic']['settingGrid']['remoteOperations'] != 'undefined') {
          this.remoteOperations = this.componentData['dynamic']['settingGrid']['remoteOperations']
        }
        if (typeof this.componentData['dynamic']['settingGrid']['mode'] != 'undefined') {
          this.modeEditNicaAnagrafica = this.componentData['dynamic']['settingGrid']['mode']
        }

        if (typeof this.componentData['dynamic']['settingGrid']['height']) {

          this.height = this.componentData['dynamic']['settingGrid']['height'];

        } else {
          this.height = 350 + 'px';
        }


        if (typeof this.componentData['dynamic']['settingGrid']['selectionMode'] != 'undefined') {

          this.selectionMode = this.componentData['dynamic']['settingGrid']['selectionMode'];
          if (this.selectionMode == 'multiple') {
            this.showSelectionMode = false;
          }

          if (this.selectionMode == '') {
            this.showSelectionMode = false;
          }

        }

        if (typeof this.componentData['dynamic']['settingGrid']['showColBlank'] != 'undefined') {

          this.showColBlank = this.componentData['dynamic']['settingGrid']['showColBlank']
        }

        if (typeof this.componentData['dynamic']['settingGrid']['showFilterSearch'] != 'undefined') {

          this.showFilterSearch = this.componentData['dynamic']['settingGrid']['showFilterSearch']
        }

        if (typeof this.settingsComponent['settingGrid']['rowDragging'] != 'undefined') {
          this.rowDragging = {
            allowReordering: this.settingsComponent['settingGrid']['rowDragging']['allowReordering'],
            showDragIcons: this.settingsComponent['settingGrid']['rowDragging']['showDragIcons'],
          }


        }
      }

      if (typeof this.componentData['dynamic']['settingList'] != 'undefined') {
        if (typeof this.componentData['dynamic']['settingList']['remoteOperations'] != 'undefined') {
          this.remoteOperations = this.componentData['dynamic']['settingList']['remoteOperations']
        }
      }


    }


    if (this.componentData['lookup']) {

      this.keyUnique = this.componentData['lookup']['settingList']['keyUnique']
      this.settingsComponent = this.componentData['lookup']
    }


    if (typeof this.componentData != 'undefined') {
      if (this.componentData['component']) {
        this.instanceComponent(this.componentType)
      }
    }

    /*** Ottenere Data Source nelle tipologie componeti speciali***/

    if (this.apiSource != '' && (this.componentType == 'dynamicGrid' || this.componentType == 'dynamicList') && this.remoteOperations) {

      this.anagraficaService.getElenco(this.apiSource, this.filterKey, this.filterNomeTabella).then(subject => {

        if (subject['items']) {
          this.datasource = subject['items'];
        } else {
          this.datasource = subject;
        }


      });


    }


    if (this.componentType == 'dynamicGrid') {

      this.renderComponentGridToView()
    }

    if (this.componentType == 'dynamicList') {

      this.renderComponentListToView()

    }


  }

  onInitialized(event) {



    event.name = 'onInitialized';

    event.currentDataSource = this.datasource;
    event.griglia = event.component
    //console.log('onInitialized',this.datasource);  
    this.emittedGridEventInit.emit(event)





  }

  onContentReady(event) {

    /* if (!this.remoteOperations && typeof this.componentData['dynamic']['settingGrid'] != 'undefined' && this.datasource.length > 0 && this.onFirstLoad) {

      let masterKey = this.componentData['dynamic']['settingGrid']['masterKey'];
      if (typeof this.dataInput != 'undefined') {
        if (masterKey) {
          this.dataInput = this.dataInput.filter(res => res[masterKey] != null);
        }
        event.dataSource = this.dataInput;
      }

      event.campo = this.componentData['dataField'];
      event.name = 'onContentReadyFirstLoad'
      event.griglia = event.component
      this.emittedGridEventInit.emit(event);
      this.onFirstLoad = false
    } */

    //console.log('onContentReady', this.dataInput)

    if (this.componentData['dynamic']['settingGrid']) {


      if (this.dataInput && this.datasource.length > 0 && this.componentData['dynamic']['settingGrid']['selectionMode'] == 'multiple' && this.onFirstLoad) {

        this.dataInput.forEach(data => {
          if (typeof data == 'object') {
            let keyUnique = this.componentData['dynamic']['settingGrid']['keyUnique'];
            if (keyUnique) {
              let filtData = data[keyUnique]
              this.dataSelectedGrid.push(filtData);

              event.component.selectRows(filtData, true);
            }
          } else {

            this.dataSelectedGrid.push(data);
            event.component.selectRows(data, true);
          }



          this.onFirstLoad = false;

        })

        this.dataSelectedGrid = event.component.getSelectedRowsData()


        /*
        if(Array.isArray(this.dataInput)){
             this.dataInput.forEach(data => {
 
             
              
               if(keyUnique){
                 
                 this.dataSelectedGrid.push(filtData);
                 event.component.selectRows(filtData, true);
               }
             })
           }else{
             this.dataSelectedGrid.push(data);
             event.component.selectRows(data, true);
           }
 
        */
      }

      if ((this.componentData['dynamic']['settingGrid']['outputData'] || this.remoteOperations) && this.onFirstLoadContentReady && this.datasource.length > 0) {

        this.onSavingDynamiGrid(event);
        this.onFirstLoadContentReady = false;
      }


    }

    /* if(!this.remoteOperations){
      
      if(!this.added){
        
          let addColNumber = 10;
          let x = 0
          for (x; x <= addColNumber; x++) {
  
            event.component.addRow();
            //event.component.closeEditCell();
  
          }

          if(x==addColNumber){
            event.component.refresh();
            this.added = true;
          }
          
        
      }

    }
 */
    /* this.datasource.forEach((data,row)=>{

      event.component.editCell(row,'pesoScaricato');
    }) */



    //event.component.editCell(0,'pesoScaricato');

  }

  onCellPrepared(event) {
    event.name = 'onCellPrepared';

    event.currentDataSource = this.datasource;

    this.emittedGridEventInit.emit(event)

    ////console.log('datasource',this.datasource)
  }

  onRowDblClick(event) {
    alert('Prova', 'doppioClick')
  }

  onEditingStart(event) {

    event.name = 'onEditingStart';
    event.dataSource = this.datasource
    event.componentData = this.componentData;
    event.componentName = event.componentName;
    event.masterComponent = event.component;
    event.dynamicGridComponent = this

    event.name = 'onEditingStart'

    this.emittedGridEvent.emit(event)

    this.currEditIndx = event.component.getRowIndexByKey(event.key);
    if (typeof event.column != 'undefined') {
      this.currDataFieldEdit = event.column.dataField
    } else {
      this.currDataFieldEdit = event.componentData.dataField
    }



    /* let prevIndx = this.currEditIndx - 1

    if(this.currEditIndx>0){
      //console.log('CER',this.datasource[prevIndx]['cer'])
      if(!this.datasource[prevIndx]['cer']){
        event.component.closeEditCell();

        const element  = this.dynamicGridComponent.instance.getCellElement(prevIndx,'cer')
        this.dynamicGridComponent.instance.focus(element)  
      }
    } */
    //this.targetCompare = this.currEditIndexTarget[this.currEditIndx] */
  };

  onEditCanceled(event?) {
    //console.log('onEditCanceled', event)
    const dataToSend = {
      component: this.componentData,
      masterComponent: this.dynamicGridComponent.instance,
      data: this.datasource,
      name: 'onEditCanceled'
    }

    this.emittedGridEvent.emit(dataToSend);
  }
  onEditCanceling(event?) {
    //console.log('onEditCanceling', event)
    const dataToSend = {
      component: this.componentData,
      masterComponent: this.dynamicGridComponent.instance,
      data: this.datasource,
      name: 'onEditCanceling'
    }

    this.emittedGridEvent.emit(dataToSend);
  }

  onInitNewRow(e) {
    e.cancel = true;
    return;
    this.currEditIndx = 0;

    e.dataSource = this.datasource
    e.componentData = this.componentData;
    e.componentName = e.componentName;
    e.masterComponent = e.component;
    e.dynamicGridComponent = this

    e.name = 'onInitNewRow'

    this.emittedGridEvent.emit(e)
  };

  comparisonFunction = () => {

    /* if (typeof this.dynamicGridComponent != 'undefined' && typeof this.targetCompare != 'undefined'){
      return this.dynamicGridComponent.instance.cellValue(this.currEditIndx, this.targetCompare);
    }else{
      return null
    } */

  }

  validateData(event) {

    //console.log(event)

    let selectedDatasUsers = event.component.getDataSource().items();

    selectedDatasUsers.forEach(data => {

    })


  }


  getDataSource(data) {
    let filter = data.filter
    if (this.dataForm && data.filter && data.filter != '') {
      filter = this.utility.convertiFiltroDinamico(data.filter, this.dataForm)
    }


    return new CustomStore({
      loadMode: "raw",
      key: data.valueExpr,

      load: () => this.anagraficaService.getElenco(data.dataSource, '', filter).then(res => {

        if (res['items']) {
          return res['items']
        } else {
          return res
        }

      }),

    })


  }

  getDataValue(realted, dataFiled, datasource, campo) {
    //console.log('realted', realted)

    datasource.forEach(data => {

      if (data[dataFiled]) {
        this.anagraficaService.getValue(campo.dataSource, data[dataFiled], '').then(res => {

          data[realted[1]] = res[realted[0]]
        })
      } else {
        data[realted[1]] = null
      }

    })


    this.datasource = datasource;
    //console.log(this.datasource)
  }

  filterDataSourceValue(arrayObject, filter) {

    return arrayObject.map(data => {

      return data[filter]

    })
  }

  renderComponentGridToView() {

    this.cols = [];
    let Arrayrelateds = [];
    let service = '';
    let dataFields
    if (typeof this.componentData['dynamic']['settingGrid']['colonne'] != 'undefined') {

      dataFields = null
    } else {
      service = this.service;
      dataFields = this.formservice.getService(service);
    }




    if (dataFields) {
      let rowIndex = 0;
      let righe = [];
      this.currEditIndx = []
      dataFields.forEach((campo, j) => {

        if (typeof campo.data != 'undefined')
          campo.data.forEach((c, x) => {
            if (c.type != 'campoComponent' && c.type != 'colsSum') {
              /* if(typeof c.colVisible != 'undefined'){
                if(!c.colVisible){
                  return
                }
                
              } */
              if (c.validation) {
                if (c.validation[0]['type'] == 'compare') {
                  this.currEditIndexTarget[c.dataField] = {
                    ...this.currEditIndexTarget[c.dataField],
                    comparisonTarget: c.validation[0]['comparisonTarget']
                  }
                }
              }

              let formart

              if (typeof c.format != 'undefined') {
                formart = c.format
              }

              this.typeFormart[c.dataField] = c.dataType == 'number' && !c.formart ? '#,##0.000' : formart;

              if (c.type != 'simpleButton' || !c.button) {
                this.cols.push(c);
              }





            }


            if (c.type == 'colsSum') {

              this.colsSum.push(c);

            }

            if (c.type == 'simpleButton' || c.button) {

              this.colsButton.push(c.button);

            }

            if (c.lookup) {

              //console.log(c.dataField);

              this.lookUpData[c.dataField] = this.getDataSource(c.lookup);

              /*
              commento momentaneo*/
              if (c.lookup.related) {
                Arrayrelateds.push({
                  dataField: c.dataField,
                  related: c.lookup.related,
                  campo: c.lookup
                })
              }
            }
            if (c.lista) {

              console.log(c.dataField, c);
              if (c.lista.static) {
                this.lookUpData[c.dataField] = c.lista.items// this.getDataSource(c.lista);
              } else {
                this.lookUpData[c.dataField] = this.getDataSource(c.lista);
              }


              /*
              commento momentaneo*/
              if (c.lista.related) {
                Arrayrelateds.push({
                  dataField: c.dataField,
                  related: c.lista.related,
                  campo: c.lista
                })
              }
            }
            if (c.tagBoxList) {
              this.lookUpData[c.dataField] = this.getDataSource(c.tagBoxList);
              //Imposto le viariabili globali relative a gli items di tipo lookup
              setTimeout(() => {
                /*this.lookUpValue[c.dataField] = this.datasource[c.dataField];
                //console.log(c.dataField, this.lookUpData[c.dataField])*/
              }, 200);

              this.rowSelectLookUp[c.dataField] = [];
              this.rowSelectedLookUp[c.dataField] = [];
            }

            if (c.dynamic) {
              if (c.dynamic.valueExpr != '') {
                if (c.dynamic.related) {
                  Arrayrelateds.push({
                    dataField: c.dataField,
                    related: c.dynamic.related,
                    campo: c.dynamic
                  })


                }

              }
              if (c.dynamic.buttons) {
                c.dynamic.buttons.forEach((button, x) => {
                  this.otherButtonsDataField[button.name] =
                  {
                    icon: 'dx-icon glyphicon mdi mdi-playlist-plus',
                    type: 'icon',
                    onClick: ($event) => {

                      let dataRow = this.datasource[this.currEditIndx]

                      let dataToSend = {
                        name: 'customButtonGriglia',
                        buttonName: button.name,
                        campo: c,
                        event: button.event,
                        data: dataRow,
                        rowIndex: this.currEditIndx,
                        component: $event.component,
                        masterComponent: this.dynamicGridComponent.instance
                      }
                      this.emittedGridEvent.emit(dataToSend)
                    },
                  }

                })

              }
              if (c.dynamic.buttonOption) {
                this.ButtonsDataField[c.dataField] = {
                  icon: 'dx-icon glyphicon mdi mdi-playlist-plus',
                  type: 'icon',
                  onClick: ($event) => {


                    const componentType = c.dynamic.componentType

                    const cellInfo = this.dynamicGridComponent.instance.columnOption(c.dataField)

                    this.eventmitter(c, $event, componentType, c.dynamic.dataSource, c.dynamic.caption, cellInfo)


                    $event.event.stopPropagation()
                  },
                }
              }

            }
          })


      })

    } else {

      const cols = this.componentData['dynamic']['settingGrid']['colonne'];


      cols.forEach((c, x) => {
        if (c.type != 'campoComponent' && c.type != 'colsSum') {
          /* if(typeof c.colVisible != 'undefined'){
            if(!c.colVisible){
              return
            }
            
          } */
          if (c.validation) {
            if (c.validation[0]['type'] == 'compare') {
              this.currEditIndexTarget[c.dataField] = {
                ...this.currEditIndexTarget[c.dataField],
                comparisonTarget: c.validation[0]['comparisonTarget']
              }
            }
          }
          this.typeFormart[c.dataType] = c.dataType == 'number' && !c.formart ? '#0.##' : c.format;

          this.cols.push(c);



        }




        if (c.type == 'colsSum') {

          this.colsSum.push(c);

        }

        if (c.type == 'simpleButton' || c.button) {

          this.colsButton.push(c);

        }

        if (c.lookup) {

          //console.log(c.dataField);

          this.lookUpData[c.dataField] = this.getDataSource(c.lookup);

          /*
          commento momentaneo*/
          if (c.lookup.related) {
            Arrayrelateds.push({
              dataField: c.dataField,
              related: c.lookup.related,
              campo: c.lookup
            })
          }
        }
        if (c.lista) {

          //console.log(c.dataField);


          if (c.lista.static) {
            this.lookUpData[c.dataField] = c.lista.items// this.getDataSource(c.lista);
          } else {
            this.lookUpData[c.dataField] = this.getDataSource(c.lista);
          }

          /*
          commento momentaneo*/
          if (c.lista.related) {
            Arrayrelateds.push({
              dataField: c.dataField,
              related: c.lista.related,
              campo: c.lista
            })
          }
        }
        if (c.tagBoxList) {
          this.lookUpData[c.dataField] = this.getDataSource(c.tagBoxList);
          //Imposto le viariabili globali relative a gli items di tipo lookup
          setTimeout(() => {
            /*this.lookUpValue[c.dataField] = this.datasource[c.dataField];
            //console.log(c.dataField, this.lookUpData[c.dataField])*/
          }, 200);

          this.rowSelectLookUp[c.dataField] = [];
          this.rowSelectedLookUp[c.dataField] = [];
        }

        if (c.dynamic) {
          if (c.dynamic.valueExpr != '') {
            if (c.dynamic.related) {
              Arrayrelateds.push({
                dataField: c.dataField,
                related: c.dynamic.related,
                campo: c.dynamic
              })


            }

          }

          this.ButtonsDataField[c.dataField] = {
            icon: 'dx-icon glyphicon mdi mdi-playlist-plus',
            type: 'icon',
            onClick: ($event) => {


              const componentType = c.dynamic.componentType

              const cellInfo = this.dynamicGridComponent.instance.columnOption(c.dataField)

              this.eventmitter(c, $event, componentType, c.dynamic.dataSource, c.dynamic.caption, cellInfo)


              $event.event.stopPropagation()
            },
          };
        }
      })
    }
    let dataInput = []
    if (this.dataInput) {
      dataInput = this.dataInput
    }

    this.relazionaArray(Arrayrelateds);


    this.formActionType = 'insert';
    this.buttonCustom =
      [
        {
          location: "before",
          widget: "dxButton",
          locateInMenu: "never",
          text: 'Salva dati',
          icon: "glyphicon mdi mdi-content-save-outline",
          event: 'SalvaDati'

        },
      ]
    this.inSelectionState = true;






  }



  relazionaArray(Arrayrelateds: any[]) {
    setTimeout(() => {

      /*var y = 1;
      var i = 1;
      while (i <= 5) {
        let ItemCol
        this.cols.forEach(col=>{
          let colObj=
          ItemCol={...ItemCol, 
            [col.dataField]:null
          }
        })
        this.dataInput.push(ItemCol)
        i++;
      }
      //console.log('dataInput', this.dataInput);
      */
      if (typeof this.dataInput != 'undefined') {

        if (!this.remoteOperations) {
          if (this.dataInput) {
            if (this.dataInput.length > 0) {
              this.datasource = this.dataInput;
            } else this.datasource = [];

            if (Arrayrelateds.length > 0) {
              Arrayrelateds.forEach(relatedArray => {
                const related = relatedArray.related

                related.forEach(rel => {
                  let arrayRelated = rel.split('|');
                  if (arrayRelated.length > 1) {
                    const dataInput = this.dataInput.map(ress => ress[relatedArray.dataField])
                    dataInput.forEach((inputs, index) => {

                      this.datasource[index][arrayRelated[1]] = inputs.map(cc => cc[arrayRelated[0]])

                    })



                  } else {


                    this.dataInput.forEach((inputs, index) => {

                      this.datasource[index][rel] = inputs[rel]

                    })
                  }
                })



              })

            }
          }

        }




      } else {

        if (this.remoteOperations) {
          if (Arrayrelateds.length > 0) {
            Arrayrelateds.forEach(relatedArray => {
              const related = relatedArray.related

              related.forEach(rel => {
                let arrayRelated = rel.split('|');
                if (arrayRelated.length > 0) {
                  arrayRelated.forEach(r => {

                    this.getDataValue(arrayRelated, relatedArray.dataField, this.datasource, relatedArray.campo)
                  })
                } else {
                  this.getDataValue(arrayRelated, relatedArray.dataField, this.datasource, arrayRelated.campo)
                }
              })



            })

          }

        }
      }


      if (typeof this.componentData['dynamic']['dataFormFilter'] != 'undefined') {
        ////console.log('dataForm', this.dataForm)
        if (this.dataForm.length > 0) {
          this.datasource = this.dataForm
        }

      }

      if (!this.remoteOperations) {
        if (!this.showColBlank) {
          return
        }
        let index = 0

        for (index; index < 975; index++) {

          let dataSource = []
          this.cols.forEach((col, i) => {
            if (col.dataField == 'index') {
              dataSource = { ...dataSource, [col.dataField]: index }
            } else {
              if (typeof this.costantValues != 'undefined' && typeof this.settingsComponent['settingGrid']['campoTabRif'] != 'undefined') {
                const campoTabRif = this.settingsComponent['settingGrid']['campoTabRif']
                if (typeof this.costantValues[campoTabRif] != 'undefined') {
                  let value = this.costantValues[campoTabRif]
                  dataSource = { ...dataSource, [campoTabRif]: value }
                }

              }
              dataSource = { ...dataSource, [col.dataField]: null }
            }


          })

          this.datasource.push(dataSource)


        }
      } else {
        if (!this.showColBlank) {
          return
        }
        let index = this.datasource.length
        this.datasourceCopy = this.datasource
        for (index; index < 975; index++) {

          let dataSource = []
          this.cols.forEach((col, i) => {
            if (i == 0 && col.dataField == 'index') {
              dataSource = { ...dataSource, [col.dataField]: index }
            } else {
              let defaultValue = null;
              if (typeof col.defaultValue != 'undefined') {
                defaultValue = col.defaultValue
              }

              if (this.costantValues != 'undefined' && typeof this.settingsComponent['settingGrid']['campoTabRif'] != 'undefined') {
                if (this.costantValues) {
                  const campoTabRif = this.settingsComponent['settingGrid']['campoTabRif']
                  if (typeof this.costantValues[campoTabRif] != 'undefined') {
                    let value = this.costantValues[campoTabRif]
                    dataSource = { ...dataSource, [campoTabRif]: value }
                  }
                }


              }

              dataSource = { ...dataSource, [col.dataField]: defaultValue }
            }


          })

          this.datasource.push(dataSource);

        }
      }


    }, 500);


  }

  renderComponentListToView() {
    setTimeout(() => {
      if (typeof this.dataInput != 'undefined') {
        //console.log('renderComponentListToView', this.dataInput)
        this.dataInput.forEach(data => {
          this.dynamicList.instance.selectItem(data)
        })

      }

    }, 500);


    this.listButtonOptions = {
      icon: 'add',
      useSubmitBehavior: true,
      onClick($event) {
        //console.log($event)
        this.dataSetJson = [];
        this.dataSetJson['nomeTabella'] = this.nomeTabella
        this.inSelectionState = false;

      }
    }
  }

  /***Eventi Griglia E COLONNE**/

  setStateValueLook(rowData: any, value: any, currentRowData): void {



    //console.log("setStateValueLook ecco rowData ", rowData);
    //console.log("setStateValueLook ecco value ", value);
    //console.log("setStateValueLook ecco currentRowData ", currentRowData);




  }

  beforeSavingDynamiGrid(event) {
    const dataToSend = {
      event: event,
      name: 'beforeSavingDynamiGrid'
    }
    this.emittedGridEvent.emit(dataToSend)
  }

  onSavingDynamiGrid(event) {


    let check: boolean = true


    let datasource = null;
    if (!this.remoteOperations) {

      const masterKey = this.componentData['dynamic']['settingGrid']['masterKey']
      if (this.componentData['dynamic']['settingGrid']['mode'] != 'row') {
        datasource = this.datasource.filter(res =>
          res[masterKey] != null
        )
      } else {
        datasource = this.datasource;


      }

      let related;

      if (this.componentData['dynamic'].related) {
        let newItem = ''
        let dati = datasource
        //console.log(this.componentData['dynamic'].related)
        this.componentData['dynamic'].related.forEach((keyRelated, i) => {
          let keyArr = keyRelated.split('|');
          //console.log(keyArr)
          if (keyArr.length > 1) {
            newItem = { ...related, [keyArr[1]]: dati[keyArr[0]] };
          } else {
            newItem = { ...related, [keyRelated]: dati[keyRelated] };
          }


          related = newItem
        })

      }

      let dataS
      if (this.componentData['dynamic']['settingGrid']['selectionMode'] == 'multiple') {
        if (this.componentData['dynamic']['displayExpr'] != '') {
          dataS = [];
          let displayExpr = this.componentData['dynamic']['displayExpr']
          datasource.forEach(data => {
            dataS.push(data[displayExpr])
          })
        } else {
          dataS = datasource
        }
      } else {
        dataS = datasource
      }

      const dataToSend = {
        component: this.componentData,
        masterComponent: event.component,
        data: dataS,
        dataChanged: event.changes,
        related: related,
        name: 'onSavingDynamiGrid'
      }
      this.emittedGridEvent.emit(dataToSend)
      event.component.closeEditCell()
      return
    }


    //Fatto perchè dava errore quando si cliccava sul bottone salva e non ci sono modifiche nella cella
    if (typeof event.changes == 'undefined' || event.changes.length == 0) {
      event.component.closeEditCell()
      return
    }

    let type = ''
    if (event.changes[0]['type'] == 'remove') {
      type = 'remove'
    } else if (typeof event.changes[0]['data'] != 'undefined') {
      if (typeof event.changes[0]['data']['__KEY__'] != 'undefined') {
        event.changes[0]['data']['index'] = event.changes[0]['data']['__KEY__']
      }
      if (typeof event.changes[0]['data']['index'] != 'undefined' || event.changes[0]['data'][this.masterKey] == null) {
        type = 'insert'
      } else {

        type = 'update'
      }

    } else {

      type = 'update'
    }


    if (type == 'insert' && this.remoteOperations) {
      if (this.componentData['dynamic']['settingGrid']['campoTabRif']) {
        let campoTabRif = this.componentData['dynamic']['settingGrid']['campoTabRif'];

        if (typeof event.changes[0]['data'][campoTabRif] != 'undefined') {

        }

        if (this.costantValues[campoTabRif] != 'undefined') {
          event.changes[0]['data'][campoTabRif] = this.costantValues[campoTabRif]
        }
      }


      if (event.changes[0]['data']['index'] >= 0) {
        delete event.changes[0]['data']['index'];

      }


      delete event.changes[0]['data']['id'];


      let data = event.changes[0]['data']



      this.anagraficaService.actionInsert(this.apiSource, data).then(res => {
        //console.log('actionInsert-->', res)
        if (res['codeMessage'] == -1) {
          check = false;
        } else {
          check = true;


          //event.component.cancelEditData();
          //this.dynamicGridComponent.instance.refresh()
        }

      })

      setTimeout(() => {
        this.refreshData();
        this.renderComponentGridToView()
      }, 300);
    }

    if (type == 'update' && this.remoteOperations) {
      let rowData = this.dynamicGridComponent.instance.getSelectedRowsData();
      const idCampoTabRif = this.componentData['dynamic']['settingGrid']['campoTabRif'];
      if (this.componentData['dynamic']['settingGrid']['campoTabRif']) {
        if (typeof event.changes[0]['data'][idCampoTabRif] == 'undefined') {

          event.cancel = true;
          alert("Manca l'id univoco del record da modificare", 'Attenzione!');
          return

        }
        //event.changes[0]['data'][idCampoTabRif] = rowData[0][idCampoTabRif];
      }




      let data = event.changes[0]['data'];

      this.anagraficaService.actionPut(this.apiSource, data, false).then(res => {

        if (res['codeMessage'] == -1) {


          check = false
        } else {
          //console.log('dataInput in update', this.dataInput);
          check = true
          /* let displayExpr = this.componentData['dynamic']['displayExpr'] ? this.componentData['dynamic']['displayExpr'] : this.componentData['dynamic']['valueExpr'];
          let mkey = this.componentData['dynamic']['settingGrid']['masterKey'];
          let valueRetro = this.datasourceCopy.filter(ress=>ress[mkey] ==data[mkey])
          if (!Array.isArray(this.dataInput)) {
            if (valueRetro[0][displayExpr] == this.dataInput){
              let se = {
                isNotClose: true,
                data: event.changes[0]['data']
              }
              this.selectionRow(se)
            }
              check = true;
            
          } */
          this.refreshData();
          this.renderComponentGridToView();
        }
      })





    }

    if (type == 'remove' && this.remoteOperations) {
      //console.log(event.changes[0]['type'])
      const masterKey = this.componentData['dynamic']['settingGrid']['masterKey'];
      let id = event.changes[0]['key'][masterKey];
      if (!id) {
        event.cancel = true;
        alert("Manca il riferimento univoco del record da eliminare", 'Attenzione!');
        return;
      }

      this.anagraficaService.actionDelete(this.apiSource, id).then(res => {
        //console.log(res);
        if (this.componentData['dynamic']['settingGrid']['selectionMode'] != 'multiple') {
          this.refreshData();
          this.renderComponentGridToView()
          return

          let se = {
            isNotClose: true,

          }
          this.selectionRow(se)
          return
        }
      })
    }
    setTimeout(() => {
      if (!check) {
        let element = event.element
        event.component.cellValue(this.currEditIndx, this.currDataFieldEdit, null)
        event.component.focus(element)

      } else {
        this.currDataFieldEdit = null
      }

    }, 500);





    this.isGridInEdit = false

  }

  onRowValidating(event) {

    //console.log('onRowValidating', event);


    if (!event.isValid) {

      if (event.brokenRules.length == 0) {
        return
      }

      const columnIndex = event.key.index

      const dataField = event.brokenRules[0].column.dataField;

      const element = event.component.getCellElement(this.currEditIndx, dataField);

      const message = event.brokenRules[0].message;
      const value = event.component.cellValue(this.currEditIndx, dataField)
      if (!value) {
        setTimeout(() => {

          event.component.editCell(this.currEditIndx, dataField)

          event.component.focus(element);
        }, 300);

      } else {
        event.isValid = true
      }



    }

    event.name = 'onRowValidating'

    this.emittedGridEvent.emit(event)



  }

  onRowUpdating(event) {
    event.name = 'onRowUpdating'
    this.emittedGridEvent.emit(event)
  }
  onRowUpdated(event) {
    //console.log('onRowUpdated')
    event.name = 'onRowUpdated'
    this.emittedGridEvent.emit(event)
  }

  onFocusedCellChanged(event) {


    if (typeof event.row != 'undefined') {
      let row = event.row
      //console.log('onFocusedCellChanged', row)

      /*if(row.isEditing == false){
        let keyUnique = this.componentData['dynamic']['settingGrid']['keyUnique']
        let value = row.data[keyUnique];
        if(value){
   
          let ev ={
            component:event.component,
            changes:[{
              type:'insert',
              data:row.data
            }]
          }
          event.cancel = true;
         this.onSavingDynamiGrid(ev)
        }
        
        return
   
   
        
      }
      if (row.isEditing == true) {
  
        event.component.savEditData();
        return
        let keyUnique = this.componentData['dynamic']['settingGrid']['keyUnique']
        let value = row.data[keyUnique];
        if (value) {
  
          let ev = {
            component: event.component,
            changes: [{
              type: 'update',
              data: row.data
            }]
          }
          //event.cancel = true;
          this.onSavingDynamiGrid(ev)
        }
      }
  
  */

    }

  }

  onCellClick(event) {
    //console.log('onCellClick', event)
    if (!event.isEditing) {
      event.component.editRow(event.rowIndex);

    }
  }

  onEditorPrepared(evt: any): void {
    if (evt.row) {
      //evt.component.selectRowsByIndexes(evt.row.rowIndex);
      if (evt.row.isEditing) {
        this.isGridInEdit = true
      }
    }

    evt.componentData = this.componentData;
    evt.componentName = evt.componentName;
    evt.masterComponent = evt.component;
    evt.dataSource = this.datasource
    evt.name = 'onEditorPrepared'
    this.emittedGridEvent.emit(evt)
  }

  onEditorPreparing(evt: any): void {

    evt.editorOptions.onFocusOut = (args) => {
      /* if (evt.editorName === "dxNumberBox") {
        const index = evt.row.rowIndex;
        //console.log(evt.value)
        const dataField = evt.dataField
        let value = evt.row.data[dataField]
  
        if (!value) {
          value = 0
        }
        evt.component.cellValue(index, dataField, value);
      } */
      //this.onEditCanceled(evt)
    }

    if (evt.editorName === "dxSelectBox") {
      //console.log(evt.editorOptions)
      evt.editorOptions.onSelectionChanged = (e: any) => {

        ////console.log(this.checkIfItemGridExist(e.component, evt))
      }
      evt.editorOptions.onValueChanged = (e: any) => {
        //console.log(evt)
        if (this.checkIfItemGridExist(e.component, evt)) {
          //e.cancel=true
          let selectedItem = e.component.option('selectedItem')
          const index = evt.row.rowIndex

          this.lookupOptionChanged(selectedItem, evt.editorOptions, evt);
          evt.component.cellValue(index, evt.dataField, e.value);
          //evt.component.closeEditCell()
        } else {

          const index = evt.row.rowIndex;
          if (evt.row.isNewRow) {
            this.dynamicGridComponent.instance.addRow()
          } else {
            this.dynamicGridComponent.instance.editCell(index, evt.dataField);
          }
          //this.dynamicGridComponent.instance.editCell(index,evt.dataField);

        }




      }
    }
  }

  lookupOptionChanged(value, campo, cell) {


    const rowIndex = cell.row.rowIndex

    if (typeof campo.inputAttr.lookup == 'undefined' || typeof campo.inputAttr.lista == 'undefined') {
      return
    } else {



      let related = campo.inputAttr.lookup.related || campo.inputAttr.lista.related

      related.forEach(rel => {
        let arrayRelated = rel.split('|');
        if (arrayRelated.length > 0) {

          cell.component.cellValue(rowIndex, arrayRelated[1], value[arrayRelated[0]])

        } else {
          cell.component.cellValue(rowIndex, arrayRelated, value[arrayRelated])
        }


      })
    }
  }


  checkIfItemGridExist(lookupComponent, cellData) {
    if (lookupComponent.option('selectedItem') != null) {
      let cell = cellData.dataField
      let campo = cellData.editorOptions;
      let value = lookupComponent.option('selectedItem')
      if (this.componentData['dynamic']['settingGrid']['keyUnique'] == cell) {
        //console.log(value)
        let keyUnique = this.componentData['dynamic']['settingGrid']['keyUnique']
        let actualChoice = value[campo.valueExpr];

        let dataSource = this.datasource;
        let index = 0
        for (let x in dataSource) {
          //console.log(dataSource[x][keyUnique])
          if (dataSource[x][keyUnique] == value[campo.valueExpr]) {
            index++

          }

        }
        if (index > 0) {
          //cellData.cancel=true
          //lookupComponent.resetOption('selectedItem')
          cellData.component.cancelEditData();
          //const rowIndex = cellData.row.rowIndex
          //cellData.component.cellValue(rowIndex,cell,null);
          ////console.log(cellData)
          //cellData.value=null
          alert('Valore: ' + actualChoice + ' è già presente!', 'Attenzione !');





          return false
        }
        return true
      }
    }
    return true
  }


  multiselectCellTemplate(container, options) {

    if (Array.isArray(options.value)) {
      const noBreakSpace = '\u00A0';
      const icon = '<i class="gridCellIcon glyphicon mdi mdi-playlist-plus"></i>'
      const text = options.value.map(
        element => {

          let display = options.column.lookup.displayExpr
          return element[display]

        }
      );


      //container.textContent = text || noBreakSpace ;
      container.innerHTML = (text || noBreakSpace) + icon + noBreakSpace
      //container.title = text;
    } else {
      //      //console.log('multiselectCellTemplateElse', container)
      /*let desc = options.column.lookup.items.filter(re=>{
  
        return re[options.column.lookup.displayExpr] == options.column.value
      })
      let descrizione = desc['descrizione'];
      options.component.cellValue(options.rowIndex, 'cerDescrizione', descrizione);*/
    }


  }

  searchAndSelect(ev) {
    //console.log(ev)

    const val = ev.component.option('value');
    //console.log(val)

    if (val.length >= 2) {
      if (this.componentData['dynamic']) {
        let dataSource
        let key = this.componentData['dynamic']['settingGrid']['masterKey']
        if (this.componentData['dynamic']['settingGrid']['searchAndSelectDataSource']) {
          dataSource = this.componentData['dynamic']['settingGrid']['searchAndSelectDataSource']
        } else {
          dataSource = this.componentData['dynamic']['dataSource']
        }

        this.anagraficaService.getValue(dataSource, val, '').then(res => {
          if (res[key]) {
            this.dynamicGridComponent.instance.selectRows(res[key], true);
            ev.component.option('value', null);
            let event = {
              data: res,
              component: this.dynamicGridComponent.instance
            }

            this.rowGridClick(event)
          }


        })
      }
      //this.dynamicGridComponent.instance.searchByText(val)
    }

  }

  searchAndSelectReady(ev) {
    ev.component.focus()
  }

  interceptEvent(ev) {

    if (ev.name == 'ErrorLoader') {
      const dataToSend = {

        component: this.componentData,
        data: []

      }
      this.emittendSelectionRow.emit(dataToSend)
    }
    if (ev.name == 'onRowUpdated') {
      //console.log(ev)
      ev.masterThis.selezionaRiga(ev.key)
      let data = ev.masterThis.griglia.instance.getSelectedRowsData()
      this.selectedDataGrid = data;
      const dataToSend = {

        component: this.componentData,
        data: data[0]

      }
      this.emittedGridEvent.emit(dataToSend)
    }

    if (ev.name == 'onInitNewRow') {
      //console.log(ev)
      ev.componentData = this.componentData;
      ev.componentName = ev.componentName;
      ev.masterComponent = ev.masterComponent
      this.emittedGridEvent.emit(ev)
    }

    if (ev.name == 'onEditorPrepared') {

      ev.componentData = this.componentData;
      ev.componentName = ev.componentName;
      ev.masterComponent = ev.masterThis
      this.emittedGridEvent.emit(ev)
    }

  }

  async getDesCer(cer) {
    try {
      let xx = await this.appService.GetApiBackEnd('Cer/' + cer)
      return xx['descrizione']
    } catch (error) {
      return ''
    }

  }
  async getDesCer1(cer, dt) {
    let xx = await this.appService.GetApi('Cer/' + cer)
    dt[dt.length - 1] = {
      cer: cer,
      cerDescrizione: xx['descrizione']
    }
  }

  toolbarPreparing(event) {
    //console.log('toolbarPreparing', event)

    let addRowButton = event.toolbarOptions.items.find(x => x.name === "addRowButton");
    //console.log(addRowButton)



    if (addRowButton) {
      addRowButton.showText = "always";
      addRowButton.options.icon = "dx-icon export icon-plus-circled";
      addRowButton.options.text = this.desButtonAdd ? this.desButtonAdd : 'Nuovo';

      if (typeof this.componentData['dynamic']['settingGrid'] != 'undefined') {
        if (this.componentData['dynamic']['settingGrid']['mode'] == 'cell') {
          addRowButton.options.onClick = ($event) => {
            $event.event.stopPropagation()
            $event.cancel = true
            //e.componentName = this.name;
            $event.masterComponent = this;
            let datafield
            //console.log('addRowButton', $event)
            let datafieldStart = this.dynamicGridComponent.instance.getVisibleColumns()
            if (datafieldStart.length > 0) {
              datafieldStart = datafieldStart.filter(fieldT => fieldT.type != 'buttons' && fieldT.allowEditing == true)

            }

            let firstData = this.datasource.find(res => res[this.masterKey] == null)
            let rowIndex = this.dynamicGridComponent.instance.getRowIndexByKey(firstData);

            if (datafieldStart.length > 0)
              datafield = datafieldStart[0].dataField;




            this.dynamicGridComponent.instance.editCell(rowIndex, datafield)


            //risp = this.onAllEvent.emit($event);
            //if (risp) $event = risp
            ////////console.log("MYDS ",that.griglia);
            //if (!$event.cancel) that.griglia.instance.addRow();
          };
        } else if (this.componentData['dynamic']['settingGrid']['mode'] == 'row' && this.showColBlank) {
          addRowButton.options.onClick = ($event) => {



            $event.cancel = true
            //e.componentName = this.name;
            $event.masterComponent = this;

            ////console.log('addRowButton', $event)
            let firstData = this.datasource.find(res => res[this.masterKey] == null)
            let rowIndex = this.dynamicGridComponent.instance.getRowIndexByKey(firstData);
            if (rowIndex < 0) {
              rowIndex = 0;
            }
            this.dynamicGridComponent.instance.editRow(rowIndex)



            //risp = this.onAllEvent.emit($event);
            //if (risp) $event = risp
            ////////console.log("MYDS ",that.griglia);
            //if (!$event.cancel) that.griglia.instance.addRow();
          };
        } else if (this.componentData['dynamic']['settingGrid']['mode'] == 'row' && !this.showColBlank) {



          addRowButton.options.onClick = ($event) => {

            let risp = null;

            // $event.cancel = true
            $event.name = 'buttonNewRowEvent';
            $event.masterComponent = this;
            $event.dynamicGridComponentinstance = this.dynamicGridComponent.instance;
            risp = this.emittedGridEvent.emit($event)


            if (risp) {
              $event = risp
            }
            //////console.log("MYDS ",that.griglia);
            if (!$event.cancel) this.dynamicGridComponent.instance.addRow();
          };

        }
      }


    }

    if (this.componentData['dynamic']['settingGrid']['enabledCustomButton']) {


      this.PulsantiSuNavBar = [
        {
          location: 'after',
          options: {
            icon: 'paste',
            title: 'Icolla',
            text: '',
            index: 1,
            id: "uno",
          }
        },
        {
          location: 'after',
          options: {
            icon: 'trash',
            title: 'Elimina Tutti',
            text: '',
            index: 2,
            id: "due"
          }
        }

      ]
      let toolbarButtons = event.toolbarOptions.items



      toolbarButtons.push(
        {

          location: 'after',
          widget: 'dxButton',
          cssClass: "myClass",
          visible: false,
          options: {
            icon: 'paste',
            text: 'Icolla',
            elementAttr: { title: 'Incolla dati' },
            onClick: async () => {
              let promiseArr = [];
              navigator.clipboard.readText().then(async (dataPaste) => {
                if (dataPaste.length == 0) {
                  alert('Nessun valore da incollare', 'Attenzione!')
                  return
                }
                let arrayData;
                const dynamicGrid = this.dynamicGridComponent.instance
                const column = dynamicGrid.getVisibleColumns(1);
                let rowIndex = dynamicGrid.getDataSource().items().length + 1
                ////console.log(column)
                //------------------------------
                let cerPasteArr = [];
                let cerPasteArrResult = [];
                let cerPaste = dataPaste;

                if (!cerPaste.includes("-")) {
                  let result = cerPaste.replace(/\*/g, '');
                  cerPasteArr = result.split(".");//cerPaste.split(".");
                  let idx = -1;
                  let mioCer = "";
                  // Nuova Procedura --------------------------
                  let resultCer = "";

                  //--------------------------------------------
                  //cerPasteArr.forEach(async (element) => 
                  for (let t = 0; t < cerPasteArr.length; t++) {
                    let element = cerPasteArr[t]
                    idx++;
                    if (element.length == 2) resultCer += element;
                    if (element.length == 4) {
                      resultCer = element.substring(2)
                      let currentCer = "";
                      if (mioCer == "") {
                        currentCer = cerPasteArr[idx - 2] + cerPasteArr[idx - 1] + element.substring(0, 2);
                        mioCer = element.substring(2)
                        let indx = this.datasource.findIndex(d => d.cer == currentCer)
                        if (indx == -1) {
                          let pippo = await this.getDesCer(currentCer);
                          if (pippo > '')
                            this.datasource.push({
                              cer: currentCer,
                              cerDescrizione: pippo
                            })
                        }
                      } else {
                        currentCer = mioCer + cerPasteArr[idx - 1] + element.substring(0, 2);
                        mioCer = element.substring(2)
                        let indx = this.datasource.findIndex(d => d.cer == currentCer)
                        if (indx == -1) {
                          let pippo = await this.getDesCer(currentCer);
                          if (pippo > '')
                            this.datasource.push({
                              cer: currentCer,
                              cerDescrizione: pippo
                            })
                        }
                      }
                    }
                  };
                  //----------------------------------------------------
                  if (resultCer) {
                    let indx = this.datasource.findIndex(d => d.cer == resultCer)
                    if (indx == -1) {
                      let pippo = await this.getDesCer(resultCer);
                      if (pippo > '')
                        this.datasource.push({
                          cer: resultCer,
                          cerDescrizione: pippo
                        })
                    }
                  }

                  //-----------------------------------------------------
                  this.onSavingDynamiGrid(null);
                  dynamicGrid.refresh()

                } else                  //--------------------------
                  if (dataPaste.includes("\r\n")) {
                    arrayData = dataPaste.split("\r\n");
                    for (let t = 0; t < arrayData.length; t++) {
                      let data = arrayData[t]
                      ////console.log(data)
                      if (String(data)) {
                        /*  dynamicGrid.addRow();
                         dynamicGrid.editCell(rowIndex,'cer',data);
                         dynamicGrid.saveEditData();
                         */
                        let result = data.replace(/\./g, '')
                        data = result
                        let indx = this.datasource.findIndex(d => d.cer == data)
                        if (indx == -1) {
                          let pippo = await this.getDesCer(data);
                          this.datasource.push({
                            cer: data,
                            cerDescrizione: pippo
                          })
                        }




                        rowIndex++
                      }
                    }
                    this.onSavingDynamiGrid(null);
                    dynamicGrid.refresh()

                  }

              })
            }
          }

        }
      );




    }

    if (typeof this.componentData['dynamic']['settingGrid']['toolbarButtons'] != 'undefined') {

      const settingGridToolBarButtons = this.componentData['dynamic']['settingGrid']['toolbarButtons']

      let toolbarButtons = event.toolbarOptions.items

      settingGridToolBarButtons.forEach(button => {
        toolbarButtons.push(
          {

            location: button.location,
            widget: button.widget ? button.widget : 'dxButton',
            cssClass: button.class,
            options: {
              icon: button.icon,
              text: button.text,
              name: button.name,
              elementAttr: {
                campo: this.componentData
              },
              onClick: ($event) => {

                let emitEvent = {
                  event: $event,
                  masterComponent: this.dynamicGridComponent.instance,
                  name: 'gridToolBarButtonClick',
                  eventName: button.event,
                  dataSource: this.datasource,
                  componentData: this.componentData,
                  costantValues: this.costantValues,
                  dynamicContent: this
                }



                this.emittedGridEvent.emit(emitEvent);

              }
            }
          }

        )
      })

    }

    let emitEvent = {
      event: event,

      name: 'toolBarPreparing',
      toolbarOptions: event.toolbarOptions,
      dataSource: this.datasource,
      dynamicContent: this
    }
    this.emittedGridEvent.emit(emitEvent);
  }
  preparaToolbar(e) {

    e.toolbarOptions.items.unshift(

      {
        location: "after",

        widget: "dxButton",
        locateInMenu: "auto",
        useSubmitBehavior: true,
        options:
        {

          icon: "add",

          onClick: ($event) => {
            this.dataSetJson = [];
            this.inSelectionState = false;
            this.dataSetJson['nomeTabella'] = this.filterNomeTabella;
            setTimeout(() => {
              ////console.log(this.dynamicForm);
              //this.dynamicForm.titleDynamic = 'Inserisci ';
            }, 100);



          }
        }
      });
  }
  /** Eventi Griglia **/
  onKeyDown(event) {



    if (event.event.ctrlKey && event.event.key === "+") {

      this.dynamicGridComponent.instance.addRow()
    }
    // //console.log('onKeyDown griglia-->',event)

  }

  onSelectionChanged(event) {
    //this.rowGridClick()

    const dataToSend = {

      componentData: this.componentData,
      data: event.selectedRowsData,
      masterComponent: event.component,
      name: 'selectionRowGridList'
    }
    ////console.log(dataToSend)

    this.emittedGridEvent.emit(dataToSend)

  }
  /**Funzioni**/
  instanceComponent(component, data?) {

    return;

    /* if (this.containerComponent) {
      this.componentRef.destroy()
    } */



    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === component);


    const componentFactory: ComponentFactory<any> = this._componentFactoryResolver.resolveComponentFactory(factoryClass);


    setTimeout(() => {
      const inputs = componentFactory.inputs

      /*  for(let i in inputs){
   
         inputs[i] = data[i]
       } */


      this.componentRef = this.containerComponent.createComponent(componentFactory);


      this.componentRef.instance.itemData = data;

      console.warn('istanza', this.componentRef);

      if (this.componentRef.instance.close()) {

        this.componentRef.instance.close = this.componentRef.instance.close.bind(this);

      }

    }, 500);



    ////console.log(outputFunction)



    //this.componentRef.instance.outputEvent.subscribe(val => {
    //  this.outputFunction(val)
    //});

    //.dataFunction = 




  }




  /**EVENTI TOOLBAR***/

  selectionRow(event) {




    let dati
    if (event.data) {

      dati = event.data
    } else {

      dati = event
    }

    /* if (event.key) {
      return
    } */

    /* if(dati.items.length>0){
      dati = dati.items[0];
    } */


    let displayExpr = this.componentData['dynamic'].displayExpr;
    let valueExpr = this.componentData['dynamic'].valueExpr;

    let related;

    if (this.componentData['dynamic'].related) {
      let newItem = ''
      //console.log(this.componentData['dynamic'].related)
      this.componentData['dynamic'].related.forEach((keyRelated, i) => {
        let keyArr = keyRelated.split('|');
        //console.log(keyArr)
        if (keyArr.length > 1) {
          if (typeof dati[keyArr[0]] != 'undefined') {
            newItem = { ...related, [keyArr[1]]: dati[keyArr[0]] };
          }

        } else {
          newItem = { ...related, [keyRelated]: dati[keyRelated] };
        }


        related = newItem
      })


    }

    let value

    if (Array.isArray(displayExpr)) {
      value = []
      displayExpr.forEach(display => {
        let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
        let isMatch = dateType.test(dati[display]);

        if (isMatch) {
          if (dati[display]) {
            let date = new Date(dati[display])
            let month = date.getMonth();
            month = month + 1
            let monthS = month.toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');
            dati[display] = '' + day + '/' + monthS + '/' + date.getFullYear()
            value.push(dati[display]);
          }

        } else {
          if (dati[display]) {
            value.push(dati[display]);
          }

        }



      })
      displayExpr = 'displayExpr'
    } else {
      const key = displayExpr.trim()

      value = dati[key];
    }

    /* if(valueExpr){
      value = dati[valueExpr];
    } */

    /* if(!value){
      return
    }
  */
    let isNotClose = false
    if (event.isNotClose) {
      isNotClose = event.isNotClose
    }

    const dataToSend = {

      component: this.componentData,
      isNotClose: isNotClose,
      data: {
        selectRow: dati,
        [valueExpr]: dati[valueExpr],
        [displayExpr]: value,
        related,
        costantValues: this.costantValues
      }

    }
    ////console.log(dataToSend)
    this.emittendSelectionRow.emit(dataToSend)
    /* } else {
  
      this.emittendSelectionRow.emit(dati);
      return
    } */

    /*event.event.preventDefault();
    event.event.stopPropagation();*/
  }

  rowGridClick(event) {

    if (event.rowType == "group") {
      event.component.collapseRow(event.rowIndex);
      return
    }
    /*
    da rivedere con antonio.. 
   
    if((event.rowElement as HTMLElement)){
   
   
   
   
       if((event.rowElement as HTMLElement).children.item(1).children.item(0).className.endsWith('closed')){  //!this.dynamicGridComponent.instance.isRowExpanded(key)
         
         event.component.collapseAll(-1);
         event.component.expandRow(key);
         
       }else
       event.component.collapseRow(key);
       
     }
     */

    if (this.componentData['dynamic']['settingGrid']['selectionMode'] != 'multiple') {
      if (event.data.index >= 0 || this.showDetail) {
        if (this.showDetail) {


          var key = event.component.getKeyByRowIndex(event.rowIndex);
          event.component.expandRow(key);

          /*
          var expanded = event.component.isRowExpanded(key);
          if (expanded) {
            event.component.collapseRow(key);
          }
          else {
            event.component.expandRow(key);
          }
          */
        }
        return
      }
      this.selectionRow(event)
      return
    }



    let keyUnique = this.componentData['dynamic']['settingGrid']['keyUnique'];
    let displayExpr = this.componentData['dynamic'].displayExpr;
    let dataDisplay = [];
    let item

    item = this.dataSelectedGrid;

    let index = this.dataSelectedGrid.findIndex(res => {

      return res[keyUnique] == event.data[keyUnique]

    })

    if (index == 0) {
      this.dataSelectedGrid.splice(index, 1);
      event.component.deselectRows(event.data[keyUnique]);



    }

    if (item == 0 && index > 0) {

      event.component.selectRows(event.data[keyUnique], true);

      this.dataSelectedGrid.push(event.data)



    } else {

      if (Array.isArray(this.dataSelectedGrid)) {
        if (index < 0) {
          this.dataSelectedGrid.push(event.data);
        }
        this.dataSelectedGrid.forEach(data => {
          dataDisplay.push(data[displayExpr])
          event.component.selectRows(data[keyUnique], true)
        })

      } else {

        dataDisplay = event.data[displayExpr];

      }

    }




    /*  } else {
       dataDisplay = [];
       this.dataSelectedGrid = []
     } */
    let related;

    if (this.componentData['type'] == "campoSpecial") {
      let displayExpr = this.componentData['dynamic'].displayExpr;
      let valueExpr = this.componentData['dynamic'].valueExpr;


      if (this.componentData['dynamic'].related) {
        let newItem = ''

        this.componentData['dynamic'].related.forEach((keyRelated, i) => {
          let keyArr = keyRelated.split('|');



          if (keyArr.length > 1) {
            newItem = { ...related, [keyArr[1]]: this.dataSelectedGrid };
          } else {
            newItem = { ...related, [keyRelated]: this.dataSelectedGrid };
          }


          related = newItem
        })

      }


      /* const dataToSend = {
  
        component: this.componentData,
        data: dataDisplay,
        related,
        name: 'selectionRowGridList'
      }
      ////console.log(dataToSend)
  
      this.emittendSelectionRow.emit(dataToSend)
  */
    }


  }

  selectionRowList(event) {
    //console.log(event)

    if (event.addedItems.length > 0) {
      let item = event.addedItems[0];
      this.dataSelectedList.push(item)
    } else {

      let item = event.removedItems[0];
      let index = this.dataSelectedList.findIndex(selItem => { return selItem === item })

      this.dataSelectedList.splice(index, 1)
    }



    const dataToSend = {

      component: this.componentData,
      data: this.dataSelectedList,
      name: 'selectionItemList',
      masterComponent: event.component

    }

    this.emittedGridEvent.emit(dataToSend)

  }

  editData(ev, rowData) {
    ev.stopPropagation();

    let dataSet = rowData.data
    //console.log(dataSet)
    this.dataSetJson = dataSet;
    //this.filterKey = dataSet.id

    this.inSelectionState = false;
    this.formActionType = 'edit'

    ev.preventDefault();

  }

  removeData(ev, rowData) {
    //console.log(rowData)
    ev.stopPropagation();

    this.anagraficaService.actionDelete(this.apiSource, rowData.data.id).then(subject => {

      //console.log(subject);
      this.refreshData();

      const dataToSend = {

        component: this.componentData,
        data: {
          id: '',
          descrizione: '',
          related: []
        }
      }

      this.emittendSelectionRow.emit(dataToSend)
    });

  }

  messaggioFromComponent(message: messagefromComponent) {
    //console.log(message)
    if (message.codeMessage > 0 && message.destComponent == 'nicaDynamicContentComponent') {
      this.inSelectionState = true;

      setTimeout(() => {

        this.refreshData()
      }, 300);


    }
  }

  public refreshData() {
    this.anagraficaService.getElenco(this.apiSource, this.filterKey, this.filterNomeTabella).then(subject => {

      if (subject['items']) {
        this.datasource = subject['items'];
      } else {
        this.datasource = subject;

      }

      this.dynamicGridComponent.instance.refresh()

    });
  }

  customizeTextSummary(data) {
    console.log('customizeTextSummary-->', data);
    return `Totale: ${data.value.toFixed(3)}`;
  }

  textBoxFocusOut(cellInfo, TextBoxEvent, campo) {
    // //console.log('cellInfo', cellInfo)
    //console.log('TextBoxEvent', TextBoxEvent);
    let valueCampo = TextBoxEvent.component.option('value')
    if (!valueCampo) {
      return
    }
    let masterKey = this.componentData['dynamic']['settingGrid']['masterKey'];

    let indx = 0;

    let dataSourceCheck = this.datasource.filter(ress => ress[masterKey] != null)

    let indexCeck
    let valueCheck
    for (let x in dataSourceCheck) {

      if (dataSourceCheck[x][masterKey] == valueCampo) {
        indx++
        indexCeck = x
      }

    }

    if ((indx > 0)) {
      valueCheck = dataSourceCheck[indexCeck][masterKey]
      notify({
        message: 'Valore: ' + valueCampo + ' è già presente!',
        height: 55,
        width: 450,
        position: 'center center'

      }, 'warning', 3000);
      //this.dynamicGridComponent.instance.editCell(this.currEditIndx, campo.dataField)
      this.dynamicGridComponent.instance.cellValue(this.currEditIndx, masterKey, null)
      const element = this.dynamicGridComponent.instance.getCellElement(this.currEditIndx, campo.dataField)
      this.dynamicGridComponent.instance.focus(element);

      return

    }


    if (!campo.dynamic.autocomplete) {
      /***SE IL VALUEEXPR E IMPOSTATO FARE LA CHIAMATA getElementValue PER OTTENERE LA DESCRIZIONE NEL CAMPO RELAZIONATO***/
      if (campo.dynamic.valueExpr != '') {



        this.dynamicGridComponent.instance.cellValue(cellInfo.rowIndex, campo.dataField, valueCampo)
        this.getElementValue(valueCampo, campo, cellInfo)
        TextBoxEvent.component.option('value', valueCampo)
        return
      }

      if (typeof campo.dynamic.checkValue != 'undefined') {
        if (campo.dynamic.checkValue.forceInsert) {
          this.dynamicGridComponent.instance.cellValue(cellInfo.rowIndex, campo.dataField, valueCampo)
          TextBoxEvent.component.option('value', valueCampo)
        }

      }

    }
  }

  /**Ottieni il valore tramite API */
  getElementValue(value, campo, cellInfo?) {
    //  //console.log( evento + ' - '+ value,campo.dataField)
    if (value) {
      let rel = ''
      if (!Array.isArray(value)) {

        let queryString
        if (campo.dynamic.queryString) {
          if (campo.dynamic.queryString.includes('$')) {
            let arrQuerySTemp = campo.dynamic.queryString.split('$');

            let query = arrQuerySTemp[0];
            let filter = ''
            const dataSet = arrQuerySTemp[1].split('&')[0];
            if (dataSet == campo.dataField) {
              filter = value;
              value = '';
            } else {
              if (typeof this.datasource[dataSet] != 'undefined') {

                filter = this.datasource[dataSet];
              }
            }


            /* if(arrQuerySTemp[1]=='value'){
              filter = value;
              value='';
            } */

            if (typeof filter != 'undefined') {
              queryString = query + filter
            }

          } else {
            queryString = campo.dynamic.queryString
          }
        }

        this.anagraficaService.getValue(campo.dynamic.dataSource, value, queryString).then(res => {



          if (res['items']) {
            res = res['items']
          }


          let newItem;
          if (!campo.dynamic.related) {
            return
          }
          campo.dynamic.related.forEach((value, key) => {
            let arrayValue = value.split('|')
            let displayValue = ''
            if (arrayValue.length > 1) {
              if (arrayValue[0].includes(',')) {
                const values = arrayValue[0].split(',');

                let lengthVal = values.length - 1

                values.forEach((val, index) => {

                  let separator = ''
                  if (index < lengthVal) {
                    separator = ' - '
                  }

                  let value = this.dateParse(res[val])
                  displayValue += value + separator;
                })
              } else {
                let value = this.dateParse(res[arrayValue[0]])
                displayValue = value
              }

              newItem = { ...this.datasource, [arrayValue[1]]: displayValue };
              this.dynamicGridComponent.instance.cellValue(cellInfo.rowIndex, arrayValue[1], displayValue)
            } else {
              if (value.includes(',')) {
                const values = value.split(',');

                let lengthVal = values.length - 1

                values.forEach((val, index) => {
                  let separator = ''
                  if (index < lengthVal) {
                    separator = ' - '
                  }
                  displayValue += res[val] + separator;
                })
              } else {
                displayValue = res[value]
              }
              newItem = { ...this.datasource, [value]: displayValue };
            }
            //this.datasource = newItem,

            this.dynamicGridComponent.instance.cellValue(cellInfo.rowIndex, value, displayValue)
          })


        }).catch(error => {
          //console.log(error)
          //alert('Valore inesistente', 'Attenzione!');
          this.datasource[campo.dataField] = null;
          //this.dynamicGridComponent.instance.updateData(campo.dataField, null)
          this.dynamicGridComponent.instance.cellValue(cellInfo.rowIndex, campo.dataField, null)
          //const editor = this.formEdit.instance.getEditor(campo.dataField);

          //editor.focus();

          let related = campo.dynamic.related;


          if (related) {
            related.forEach((value, key) => {
              let arrayValue = value.split('|')
              if (arrayValue.length > 1) {
                //this.datasource[arrayValue[1]] = '';
                //this.formEdit.instance.updateData(arrayValue[1], null)

                this.dynamicGridComponent.instance.cellValue(cellInfo.rowIndex, arrayValue[1], null)
              } else {
                //this.datasource[value] = '';
                this.dynamicGridComponent.instance.cellValue(cellInfo.rowIndex, value, null)
              }

            })
          }
          this.dynamicGridComponent.instance.editCell(this.currEditIndx, campo.dataField)

          return

        })
      }

    }

  }
  //Parsing della data con l'orario
  public dateParse(dateTime) {
    let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
    let isMatch = dateType.test(dateTime);

    if (isMatch) {
      let date = new Date(dateTime)
      let month = ("0" + (date.getMonth() + 1)).slice(-2); month + 1
      let day = date.getDate().toString().padStart(2, '0');

      return day + '-' + month + '-' + date.getFullYear();

    } else {
      return dateTime
    }
  }

  /* emittendButtonPush(event) {
  
    if (event == 'SalvaDati') {
      let form = this.dynamicForm.formEdit
      //console.log(this.apiSource);
      //console.log(ValidationEngine.validateGroup(this.apiSource));
      let validation = ValidationEngine.validateGroup(this.apiSource); //per validare il form x nome ?!?
  
      //console.log(validation)
      if (validation.isValid) {
  
  
        const formData = form.instance.option("formData");
        //console.log(formData)
        if (!formData) {
          alert('I campi non possono essere vuoti', 'Attenzione!')
  
          return
        }
        if (this.formActionType == 'edit') {
          ////console.log('edit');
  
          this.anagraficaService.actionPut(this.apiSource, formData).then(result => {
  
            this.dataSetJson = result
  
            notify({
              message: 'Anagrafica salvata',
              position: {
                my: 'bottom center',
                at: 'bottom center',
              },
            }, 'success', 3000);
  
  
  
  
          });
  
        } else {
          delete formData['id']
  
          let check = this.dynamicForm.IsJsonString(formData);
          //console.log(check)
          let jsonData;
          if (!check) {
            jsonData = { ...formData };
          } else {
            jsonData = formData;
          }
  
          this.anagraficaService.actionInsert(this.apiSource, jsonData).then(result => {
  
  
  
            if (result['codeMessage'] == -1) {
  
              notify({
                message: result['descrMessage'],
                position: {
                  my: 'center center',
                  at: 'center center',
                },
              }, 'error', 3000);
  
              return false;
            } else {
  
              notify({
                message: 'Anagrafica salvata',
                position: {
                  my: 'bottom center',
                  at: 'bottom center',
                },
              }, 'success', 3000);
  
              this.dataSetJson = result;
  
            }
  
  
  
          });
  
  
  
  
        }
  
  
        setTimeout(() => {
  
          this.refreshData()
        }, 300);
  
      }
      //alert('salva dati trasporto','salva')
    }
  } */

  popUpToolbarEvent(event) {

  }

  dropDownValue(component, cellValue, tagBoxList) {
    //console.log(component)
    //console.log(cellValue);

    const text = cellValue.map(
      element => {

        let display = tagBoxList.displayExpr
        return element[display]

      }
    );
    //console.log(text)
    component.option('value', text)
  }

  gridSelValues(component, cellValue, tagBoxList) {

    const text = cellValue.map(
      element => {

        let display = tagBoxList.displayExpr
        return element[display]

      }
    );
    //console.log('selectedRowKeys', text)
    component.selectRows(text, true)
  }

  selectionChangedLookUp(event, cellInfo, dropDownBoxComponent) {
    //console.log(cellInfo)
    cellInfo.setValue(event.selectedRowsData);
    if (event.selectedRowsData.length > 0) {
      //console.log(dropDownBoxComponent)
      dropDownBoxComponent.option('value', event.selectedRowKeys);
    }
  }
  searchValueStringSpecial(event, cellInfo, dropDownBoxComponen) {

  }

  rowClickLookUp(event, campo, cellInfo) {

    //console.log(campo)

    const valueArray = event.data;
    //console.log(valueArray)
    const valueExpr = campo.tagBoxList.valueExpr

    const dataCheck = this.rowSelectLookUp[campo.dataField].find(rows => rows[valueExpr] == valueArray[valueExpr]);
    //console.log(dataCheck)

    if (!dataCheck) {
      this.rowSelectLookUp[campo.dataField].push(valueArray);
      this.rowSelectedLookUp[campo.dataField].push(valueArray[valueExpr]);


      this.datasource[campo.dataField] = this.rowSelectLookUp[campo.dataField];

      //console.log(this.datasource[campo.dataField])
      //console.log('rowSelectLookUp', this.rowSelectLookUp[campo.dataField])
    } else {

      let index = this.rowSelectLookUp[campo.dataField].findIndex(rows => { return rows[valueExpr] == valueArray[valueExpr] });
      this.rowSelectLookUp[campo.dataField].splice(index, 1);
      this.rowSelectedLookUp[campo.dataField].splice(index, 1);
      this.datasource[campo.dataField] = this.rowSelectLookUp[campo.dataField];
      //console.log(this.datasource[campo.dataField])
    }
    //console.log(this.datasource)
    //cellInfo.setValue(this.rowSelectLookUp[campo.dataField]);    


    /*const newItem = { ...this.dataSet, [keyVariable]: this.rowSelectLookUp[campo.dataField] };
    
    this.dataSet = newItem*/
  }

  public refreshDataSource(data?) {
    if (this.remoteOperations) {
      this.anagraficaService.getElenco(this.apiSource, this.filterKey, this.filterNomeTabella).then(subject => {
        let res
        if (subject['items']) {
          this.datasource = subject['items'];
        } else {
          this.datasource = subject;
        }

        this.dynamicGridComponent.instance.refresh()
        const dataToSend = {
          component: this.componentData,
          data: this.datasource,
          related: null,
          masterComponent: this.dynamicGridComponent.instance,
          name: 'onSavingDynamiGrid'
        }
        this.emittedGridEvent.emit(dataToSend)
      });
    } else {
      if (data) {
        this.datasource = data;
      } else {
        this.datasource = this.dataInput;
      }

      this.dynamicGridComponent.instance.refresh();
      this.renderComponentGridToView()

    }



  }



  saveAndExit($event) {

    let dataS = [];



    this.dataSelectedGrid = this.dynamicGridComponent.instance.getSelectedRowsData()

    if (this.componentData['dynamic']['settingGrid']['selectionMode'] != 'multiple') {
      if (this.componentData['dynamic']['displayExpr'] != '') {
        dataS = [];
        let displayExpr = this.componentData['dynamic']['displayExpr']
        this.dataSelectedGrid.forEach(data => {
          dataS.push(data[displayExpr])
        })
      }
    } else {
      let displayExprData = this.componentData['dynamic'].displayExpr ? this.componentData['dynamic'].displayExpr : this.componentData['dynamic'].valueExpr;
      dataS = this.dataSelectedGrid.map(res => {
        return res[displayExprData]
      })

    }

    let related;

    if (this.componentData['type'] == "campoSpecial") {
      let displayExpr = this.componentData['dynamic'].displayExpr;
      let valueExpr = this.componentData['dynamic'].valueExpr;


      if (this.componentData['dynamic'].related) {
        let newItem = ''

        this.componentData['dynamic'].related.forEach((keyRelated, i) => {
          let keyArr = keyRelated.split('|');
          let dataSelected = this.dataSelectedGrid


          if (keyArr.length > 1) {
            if (keyArr[0]) {
              dataSelected = this.dataSelectedGrid.map(res => {
                return res[keyArr[0]]
              })
            }
            newItem = { ...related, [keyArr[1]]: dataSelected };
          } else {
            newItem = { ...related, [keyRelated]: dataSelected };
          }


          related = newItem
        })

      }
    }



    const dataToSend = {
      component: this.componentData,
      masterComponent: this.dynamicGridComponent.instance,
      data: dataS,
      related: related,
      name: 'saveMultipleSelectionsRowGrid'
    }
    this.emittendSelectionMultipleRow.emit(dataToSend)
    return;

  }
  removeSelAndExit($event) {

    let dataS = [];

    console.warn('pippo');

    this.dataSelectedGrid = this.dynamicGridComponent.instance.getSelectedRowsData()



    if (this.componentData['dynamic']['settingGrid']['selectionMode'] == 'multiple') {
      this.dynamicGridComponent.instance.deselectAll();
      this.dataSelectedGrid = [];

    }

    let related = [];




    const dataToSend = {
      component: this.componentData,
      masterComponent: this.dynamicGridComponent.instance,
      data: this.dataSelectedGrid,
      related: related,
      name: 'saveMultipleSelectionsRowGrid'
    }
    this.emittendSelectionMultipleRow.emit(dataToSend)
    return;

  }

  eventmitter(campo, event, componentType, dataSource, caption, cellInfo) {

    this.isPanelVisible = true;


    /* 
        const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
        const factoryClass = <Type<any>>factories.find((x: any) => x.name === 'NicaDynamicContentComponent');
    
        this._overlaySidePanelService.setTitle(caption);
        this._overlaySidePanelService.setToolBarVisible(true);
        this._overlaySidePanelService.setContent(factoryClass); */






    let ngClass = 'soggetto-form'
    let height = 500;
    let width = 1200;


    if (typeof campo['dynamic']['settingGrid'] != 'undefined') {
      if (typeof campo['dynamic']['settingGrid']['height'] != 'undefined') {
        height = campo['dynamic']['settingGrid']['height'];
      }
      if (typeof campo['dynamic']['settingGrid']['width'] != 'undefined') {
        width = campo['dynamic']['settingGrid']['width'];
      }
    }

    const filerStatic = typeof campo['dynamic']['filterStatic'] != 'undefined' ? campo['dynamic']['filterStatic'] : '';
    let queryStringFilter = typeof campo['dynamic']['queryString'] != 'undefined' ? campo['dynamic']['queryString'] : '';
    let qString = ''

    let dataMaster = this.datasource[this.currEditIndx]
    if (queryStringFilter.includes('$')) {

      let arrQuerySTemp = queryStringFilter.split('$');

      let query = arrQuerySTemp[0];
      let filter = ''
      const dataSet = arrQuerySTemp[1];

      if (typeof dataMaster[dataSet] != 'undefined') {

        filter = dataMaster[dataSet];
      }


      if (typeof filter != 'undefined') {
        qString = query + filter + filerStatic
      }

    } else {
      qString = queryStringFilter + filerStatic
    }


    let queryString = qString;
    let dataFormTofilter = []
    campo['dynamic']['queryStringFilter'] = queryString;

    if (typeof campo['dynamic']['dataFormFilter'] != 'undefined') {
      let filterFormFileds = campo['dynamic']['dataFormFilter']


      dataFormTofilter = this.dataForm[filterFormFileds]



    }
    let costantValue
    if (typeof campo['dynamic']['costantValue'] != 'undefined') {
      costantValue = campo['dynamic']['costantValue'];
      let values;

      costantValue.forEach(element => {
        let keyEle = element['key'];
        let val
        if (typeof dataMaster[element['value']] != 'undefined') {
          val = this.datasource[this.currEditIndx][element['value']]
        } else {
          val = element['value'];
        }

        values = {
          ...values,

          [keyEle]: val

        }
      })

      costantValue = values
    }



    this.altezzaPopup = height;
    this.larghezzaPopup = width;

    this.panelCaption = campo['dynamic']['caption']

    let dataToSend = [{
      componentData: campo,
      apiSource: dataSource,
      componentType: componentType,
      filterKey: campo.queryString,
      height: height,
      width: '',
      costantValues: costantValue,
      dataInput: this.datasource[this.currEditIndx][campo.dataField],
      dataForm: dataFormTofilter

    }]
    //this.instanceComponent(,dataToSend);

    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === 'NicaDynamicContentComponent');

    const componentFactory: ComponentFactory<any> = this._componentFactoryResolver.resolveComponentFactory(factoryClass);


    setTimeout(() => {


      this.componentRef = this.containerComponent.createComponent(componentFactory);
      this.componentRef.instance.itemData = dataToSend;


      (this.componentRef.instance.emittendSelectionMultipleRow as EventEmitter<any>).subscribe(

        (res) => {

          let e = res;
          let component = res.component;
          let key = component.dataField;
          let newItem;
          let masterKey = this.masterKey;
          this.datasource[this.currEditIndx][key] = null;

          let indx = 0;
          if (typeof masterKey != 'undefined') {
            if (!this.datasource[this.currEditIndx][masterKey]) {
              this.dynamicGridComponent.instance.editCell(this.currEditIndx, masterKey)
              this.isPanelVisible = false;
              //this.onEditCanceled(e)
              return
            }

          }

          let dataSourceCheck = this.datasource.filter(ress => ress[masterKey] != null)


          for (let x in dataSourceCheck) {
            e.data.map(res => {
              if (dataSourceCheck[x][masterKey] == res[masterKey]) {
                indx++
              }
            })
          }

          let valueCheck
          if ((indx > 0)) {
            valueCheck = dataSourceCheck[indx][masterKey]
            notify({
              message: 'Valore: ' + valueCheck + ' è già presente!',
              height: 55,
              width: 450,
              position: 'center center'

            }, 'warning', 3000);
            //this.dynamicGridComponent.instance.editCell(this.currEditIndx, campo.dataField)
            this.dynamicGridComponent.instance.cellValue(this.currEditIndx, masterKey, null)
            //const element = this.dynamicGridComponent.instance.getCellElement(this.currEditIndx, campo.dataField)
            //this.dynamicGridComponent.instance.focus(element);

            return

          }

          if (e.data.length > 0) {

            newItem = { ...this.datasource[this.currEditIndx], [key]: e.data }

            this.datasource[this.currEditIndx] = newItem;

            this.dynamicGridComponent.instance.cellValue(this.currEditIndx, campo.dataField, e.data);

          } else {
            newItem = { ...this.datasource[this.currEditIndx], [key]: '' }
            this.datasource[this.currEditIndx] = newItem;
            this.dynamicGridComponent.instance.cellValue(this.currEditIndx, campo.dataField, null);

            this._overlaySidePanelService.close();
            this.dynamicGridComponent.instance.editCell(this.currEditIndx, campo.dataField)

            const element = this.dynamicGridComponent.instance.getCellElement(this.currEditIndx, campo.dataField)
            this.dynamicGridComponent.instance.focus(element);
            return

          }

          /***Se ci sono campi relazionari***/

          let related = e.related;

          if (related) {
            e.component.dynamic.related.forEach((value, key) => {

              this.datasource[this.currEditIndx][value] = related[value];
              //this.dynamicGridComponent.instance.cellValue(this.currEditIndx, campo.dataField, related[value]);
            })

          }



          if (e.name == 'saveMultipleSelectionsRowGrid') {
            this.isPanelVisible = false;
            this.containerComponent.clear();
            this.onEditCanceled(e);
            this.dynamicGridComponent.instance.saveEditData()
          }

        }
      );


      (this.componentRef.instance.emittendSelectionRow as EventEmitter<any>).subscribe(


        (res) => {

          let e = res;
          let valueExpr = e.component.dynamic.valueExpr != '' ? e.component.dynamic.valueExpr : e.component.dynamic.displayExpr
          let displayExpr = e.component.dynamic.displayExpr
          let value


          let masterKey = this.masterKey;
          let index = 0

          if (Array.isArray(e.data)) {

            value = e.data;

          } else {
            if (Array.isArray(displayExpr)) {
              value = e.data['displayExpr'].join(' - ');
            } else {
              value = e.data[valueExpr];
            }
          }




          let descrizione = '';

          if (e.component.dynamic.valueExpr != '') {
            descrizione = e.data[displayExpr]
          }

          let dataSourceCheck = this.datasource.filter(ress => ress[masterKey] != null)
          let indx = 0


          if (typeof masterKey != 'undefined') {
            if (masterKey != '') {
              if (!this.datasource[this.currEditIndx][masterKey] && campo.dataField != masterKey) {
                this.dynamicGridComponent.instance.editCell(this.currEditIndx, masterKey)
                this.isPanelVisible = false;
                //this.onEditCanceled(e)
                return
              }
            }


          }

          for (let x in dataSourceCheck) {
            //console.log(this.datasource[x][masterKey])
            if (dataSourceCheck[x][masterKey] == value) {
              indx++
              index = parseInt(x)
            }

          }
          let valueCheck
          if ((indx > 0)) {

            valueCheck = dataSourceCheck[index][masterKey]
            notify({
              message: 'Valore: ' + value + ' è già presente!',
              height: 55,
              width: 450,
              position: 'center center'

            }, 'warning', 3000);


            return

          }


          let key = e.component.dataField;

          /***Se ci sono campi relazionari***/

          let related = e.component.dynamic.related
          /***************************************/
          const keyVariable = key;
          const valueArray = value;

          const newItem = { ...this.datasource[this.currEditIndx], [keyVariable]: valueArray };

          this.datasource[this.currEditIndx] = newItem

          this.dynamicGridComponent.instance.cellValue(this.currEditIndx, campo.dataField, valueArray)

          if (e.component.costantValue) {

            e.component.costantValue.forEach(values => {
              this.datasource[this.currEditIndx][values.key] = values.value;
            })

          }
          if (e.data.related) {

            let rel = e.data.related
            let newItem;
            let newItemDesc;
            related.forEach((values, key) => {
              let arrayValue = values.split('|')
              if (arrayValue.length > 1) {
                newItem = { ...this.datasource[this.currEditIndx], [arrayValue[1]]: rel[arrayValue[1]] };

                this.dynamicGridComponent.instance.cellValue(this.currEditIndx, arrayValue[1], rel[arrayValue[1]])
              } else {
                newItem = { ...this.datasource[this.currEditIndx], [values]: rel[values] };
                this.dynamicGridComponent.instance.cellValue(this.currEditIndx, values, rel[values])

              }


              this.datasource[this.currEditIndx] = newItem

            })

          }


          this.isPanelVisible = false;
          this.containerComponent.clear();
          this.dynamicGridComponent.instance.saveEditData()
          this.onEditCanceled(e)
        }

      );


      (this.componentRef.instance.emittedToolbarEvent as EventEmitter<any>).subscribe(
        (res) => {


          if (res == 'close') {


            if (this.containerComponent) {

              //console.warn('stoo chiudendo nidificato',this.isPanelVisible)

              this.containerComponent.clear();

            }

            this.isPanelVisible = false;
          }



        }
      )


    }, 500);


    return
    this._overlaySidePanelService.sendDataToComponent([

      {
        componentData: campo,
        apiSource: dataSource,
        componentType: componentType,
        filterKey: campo.queryString,
        height: height,
        width: '',
        dataInput: this.datasource[this.currEditIndx][campo.dataField],
        dataForm: dataFormTofilter

      }
    ]);
    this._overlaySidePanelService.sendClassToComponent('soggetto-form')

    this._overlaySidePanelService.setPopupWidth(800);
    this._overlaySideFormService.setPopupHeight(height + 80);



    this._overlaySidePanelService.show();

    this._overlaySidePanelService.onPanelClose().subscribe(
      (ev) => {

        /*  this.datasource[this.currEditIndx][campo.dataField]
   
         this.dynamicGridComponent.instance.editCell(this.currEditIndx, campo.dataField)
   
         const element = this.dynamicGridComponent.instance.getCellElement(this.currEditIndx, campo.dataField)
         this.dynamicGridComponent.instance.focus(element);
         this.onEditCanceled()  */

      }
    )


    setTimeout(() => {


      //this._overlaySidePanelService._hrefComponent.instance.apiSource = campo.dynamic.dataSource;
      //this._overlaySidePanelService._hrefComponent.instance.copo = campo;



    }, 300)
    setTimeout(() => {


      //this._overlaySidePanelService._hrefComponent.instance.apiSource = campo.dynamic.dataSource;
      //this._overlaySidePanelService._hrefComponent.instance.copo = campo;

      (this._overlaySidePanelService._hrefComponent.instance.emittendSelectionRow as EventEmitter<any>).subscribe(



      )
    }, 300)

  }

  onShowing(e) {
    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    e.component.content().classList.add("formEditAna", "soggetto-form"); //add class to content
    e.component.content().classList.add("form-content"); //add class to content

    //console.log('onShowing', e.component.content())
  }

  popupHiding(e) {

    console.log('popupHiding', e)
    //this._overlaySideFormService.close();

    this.larghezzaPopup = undefined;

    this.altezzaPopup = undefined;

    this.isPanelVisible = false;

    this.containerComponent.clear()

    //this.componentRef.clear()
  }

  chooseRow(e) {
    //console.log('chooseRow', e)

    /* 
    commento perchè ho toloto la checkbox
    if(!e.value){
       return
     } */

    if (e.row.isEditing) {
      e.component.closeEditCell();
      return
    }
    let masterKey = ''
    if (typeof this.componentData['dynamic']['settingGrid'] != 'undefined') {
      masterKey = this.componentData['dynamic']['settingGrid']['masterKey'];
    }

    if (e.row.data.index >= 0) {
      return
    }

    setTimeout(() => {

      this.selectionRow(e.row.data)
    }, 200);

  }
  saveRow(e) {
    if (e.row.isEditing) {
      e.component.saveEditData();
      return
    }


    /*  setTimeout(() => {
       e.data = e.row.data;
       this.selectionRow(e)
     }, 500); */

  }
  colonnaButtonClick(e) {
    e.name = 'colonnaButtonClick';
    //    e.masterComponent = this.dynamicGridComponent.instance;
    //e.rowIndex = this.dynamicGridComponent.instance.getRowIndexByKey()
    this.emittedGridEvent.emit(e)
  }


  isCloneIconVisible(e) {
    return e.row.isEditing;
  }
  isSelIconVisible(e) {

    //let checkVal = isNaN(e.row.data[this.masterKey]) ? e.row.data[this.masterKey]
    if (e.row.data[this.masterKey]) {
      return true
    }
    return false;
  }
  isEditIconVisible(e) {

    /*  if(typeof this.masterKey == 'undefined'){
       return false
     }
   */
    if (e.row.data[this.masterKey]) {
      return true
    }
    return false;
  }

  rowGridDblClick(ev) {

    if (ev.data.index >= 0) {
      return
    }

    if (ev.isEditing) {
      ev.component.closeEditCell();

      this.selectionRow(ev)
    }
  }

  onDetailSelected(e) {

    //console.log(e)
    this.emittendSelectionRow.emit(e);


    /* if (e.name == 'masterDetailEdit') {
  
      e.name = 'onMasterDetailEdit';
      e.data = e.data
      e.componentData = e.detailRif;
      e.componentName = e.componentName;
      e.masterComponent = e.component;
       
      this.emittedGridEvent.emit(e)
    
    } */

    //this.emittendSelectionRow.emit(e);


    if (e.name == 'masterDetailSelection') {
      e.component.dynamic = this.componentData['dynamic'];
      this.selectionRow(e)
    }
  }
  onDetailEvents(e) {

    //console.log(e)
    this.emittedGridEvent.emit(e)



    //this.emittendSelectionRow.emit(e);


    if (e.name == 'masterDetailSelection') {
      e.component.dynamic = this.componentData['dynamic'];
      this.selectionRow(e)
    }
  }

  onRowExpanding(e) {
    e.element.classList.remove('aperto')

    this.dynamicGridComponent.instance.collapseAll(-1);
    let qString = ''
    let dataMaster = e.key;

    //this.costantValues = dataMaster;

    if (this.detailData['dynamic']['costantValue']) {

      const costantValue = this.detailData['dynamic']['costantValue'];
      let values;

      costantValue.forEach(element => {
        let keyEle = element['key'];
        let val
        if (typeof dataMaster[element['value']] != 'undefined') {
          val = dataMaster[element['value']]
        } else {
          val = element['value'];
        }

        values = {
          ...values,

          [keyEle]: val

        }
      })

      this.detailMasterData = values

    }


    let queryStringFilter = this.detailData['dynamic']['queryString'];
    const filerStatic = typeof this.detailData['dynamic']['filterStatic'] != 'undefined' ? this.detailData['dynamic']['filterStatic'] : '';

    if (queryStringFilter.includes('$')) {



      let arrQuerySTemp = queryStringFilter.split('$');



      let query = arrQuerySTemp[0];
      let filter = ''
      const dataSet = arrQuerySTemp[1];

      if (typeof dataMaster[dataSet] != 'undefined') {

        filter = dataMaster[dataSet];
      } else if (typeof this.detailMasterData[dataSet] != 'undefined') {


        filter = this.detailMasterData[dataSet];

      }


      if (typeof filter != 'undefined') {
        qString = query + filter + filerStatic
      }

    } else {
      qString = queryStringFilter + filerStatic
    }


    this.detailData['dynamic']['queryStringFilter'] = qString;
    e.element.classList.add('aperto')
  }
  onRowExpanded(e) {
    e.name = 'onRowExpanded';
    //console.log(e)
    this.emittedGridEvent.emit(e)
  }
  isShowIconDrag(e) {

    if (!e.row)
      return false

    //let checkVal = isNaN(e.row.data[this.masterKey]) ? e.row.data[this.masterKey]
    if (e.row.data[this.masterKey]) {
      return true
    }
    return false;
  }
  onReorder(e) {
    const visibleRows = e.component.getVisibleRows();

    const ID = this.masterKey

    const toIndex = this.datasource.findIndex((item) => item[ID] === visibleRows[e.toIndex].data[ID]);
    const fromIndex = this.datasource.findIndex((item) => item[ID] === e.itemData[ID]);

    this.datasource.splice(fromIndex, 1);
    this.datasource.splice(toIndex, 0, e.itemData);
    this.onSavingDynamiGrid(e)
  }

  calcDetailWidth(w) {
    if (w)
      return w - 65
  }

  close(e) {

    console.warn('sto chiudendo compoenente', this.isPanelVisible);


    this.emittedToolbarEvent.emit('close');

    //this.popupHiding(e);
  }
}


